import {Button} from '@ds/components';

type ChortkeHelpProps = {
  onClose: () => void;
};

const ChortkeHelp: React.FC<ChortkeHelpProps> = ({onClose}) => {
  return (
    <div className='p-3'>
      <p className="mb-4 text-body-xs text-gray-08">
        شما می‌توانید با کمک ابزارهایی که در چرتکه در اختیارتان قرار داده می‌شود، فروش خود را
        تحلیل کنید و تصمیم‌های بهتری برای افزایش فروش بگیرید.
      </p>
      <Button variant="outline" fullWidth onClick={onClose}>
        متوجه شدم
      </Button>
    </div>
  );
};

export default ChortkeHelp;
